export default __webpack_public_path__ + "static/media/classic02.6f980805.png";